import React from 'react';
import { useNavigate } from 'react-router-dom';
import ConsultationCountdownBanner from './ConsultationCountdownBanner';
import EventReminderModal from './EventReminderModal';
import VendorAttentionStack from './dashboard/VendorAttentionStack';
import useVendorScheduleAlerts from '../../hooks/useVendorScheduleAlerts';
import { formatLocalDate } from '../../utils/localDate';

/**
 * Consultation countdown + event “needs attention” alerts (home & dashboard).
 */
const VendorScheduleAlerts = ({
  className = '',
  /** Extra attention-stack props (verification, subscription, etc.) */
  attentionProps = null,
}) => {
  const navigate = useNavigate();
  const {
    upcomingConsultation,
    pendingConsultationCount,
    fiveDayReminderBookings,
    eventReminderByDays,
    showEventReminderModal,
    setShowEventReminderModal,
    handleCloseEventReminderModal,
  } = useVendorScheduleAlerts();

  const hasScheduleAttention =
    pendingConsultationCount > 0 || fiveDayReminderBookings.length > 0;
  const showStack = Boolean(attentionProps) || hasScheduleAttention;

  return (
    <div className={className}>
      {upcomingConsultation ? (
        <ConsultationCountdownBanner
          consultation={upcomingConsultation}
          onViewConsultations={() => navigate('/vendor/consultations')}
        />
      ) : null}

      {showStack ? (
        <VendorAttentionStack
          isVendorVerified={attentionProps?.isVendorVerified ?? true}
          isVerificationPending={attentionProps?.isVerificationPending ?? false}
          onStartVerification={attentionProps?.onStartVerification}
          hasActiveSubscription={attentionProps?.hasActiveSubscription ?? false}
          subscriptionDetails={attentionProps?.subscriptionDetails ?? null}
          isExpiringSoon={attentionProps?.isExpiringSoon ?? false}
          urgencyLevel={attentionProps?.urgencyLevel}
          onRenew={attentionProps?.onRenew}
          onComparePlans={attentionProps?.onComparePlans}
          pendingConsultationCount={pendingConsultationCount}
          onViewConsultations={() =>
            navigate('/vendor/consultations?status=pending')
          }
          fiveDayReminderBookings={fiveDayReminderBookings}
          eventReminderByDays={eventReminderByDays}
          onOpenReminder={() => setShowEventReminderModal(true)}
          onViewBookings={() => navigate('/vendor/bookings')}
        />
      ) : null}

      <EventReminderModal
        isOpen={showEventReminderModal}
        onClose={handleCloseEventReminderModal}
        bookingsByDays={eventReminderByDays}
        bookings={fiveDayReminderBookings}
        formatDate={formatLocalDate}
      />
    </div>
  );
};

export default VendorScheduleAlerts;
